import React from 'react'

import { LP_PAIR_NAME, LP_PAIR_SYMBOL } from '@/constants/lpPair'
import { cn } from '@/lib/utils'

/** Leyenda única del token LP Nutri-Matic; evita repetir nombre/símbolo en cada fila de posición. */
export function LiquidityLpTokenLegend({
  className,
  variant = 'mobile',
}: {
  className?: string
  variant?: 'mobile' | 'desktop'
}) {
  if (variant === 'desktop') {
    return (
      <div
        className={cn(
          'rounded-lg border border-primary/15 bg-primary/5 px-3 py-2.5',
          className,
        )}
      >
        <p className="text-sm font-medium text-foreground">{LP_PAIR_NAME}</p>
        <p className="mt-0.5 text-xs leading-relaxed text-muted-foreground">
          Certificado LP del Nutri-Matic (
          <span className="font-mono text-primary">{LP_PAIR_SYMBOL}</span>
          ) al aportar liquidez a un par.
        </p>
      </div>
    )
  }

  return (
    <p className={cn('text-xs leading-relaxed text-muted-foreground', className)}>
      <span className="font-medium text-foreground/90">{LP_PAIR_NAME}</span>
      {' · '}
      <span className="font-mono text-[11px] tracking-wide text-primary/90">{LP_PAIR_SYMBOL}</span>
      {' — certificado LP del Nutri-Matic al aportar a un par.'}
    </p>
  )
}
